import React, { FC } from 'react';
import { FlexboxCenter } from './Layout';
import styled, { css } from 'styled-components';

const Animation = css`
  @keyframes spinning {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }  
  }
`;
const Box = styled(FlexboxCenter)`
  ${Animation};
  
  animation: spinning 5s linear infinite;
`;

export const SpinningBox: FC = (props) => {
  return (
    <Box>
      { props.children }
    </Box>
  )
}
